import React from 'react';
import { Label, Text } from '@spark';
import { EVALUATION_NORMALIZATION_OPTIONS } from '@/features/model-setup';

const checkedLabel = (value) => (value ? 'Checked' : 'Unchecked');

/**
 * Read-only "When evaluating" rows. `source` is a usecase or a distillation
 * event (the three evaluation_* flags).
 *
 * `variant="version"` is the Model Details summary. `train` matches the Train
 * / Retrain Model Summary meta rows. `recalculate` matches the Evaluate New
 * Version benchmarks grid.
 */
export default function EvaluationNormalizationSummary({ source, variant = 'version' }) {
  const event = source || {};

  if (variant === 'train') {
    return (
      <div className="train-model-summary__meta-block">
        <Label label="When evaluating" showAsterisk={false} showIcon={false} />
        <div className="train-model-summary__meta-rows">
          {EVALUATION_NORMALIZATION_OPTIONS.map((option) => (
            <div key={option.key} className="train-model-summary__meta-row">
              <Text variant="detail-regular" color="secondary">
                {option.label}
              </Text>
              <Text variant="detail-regular">
                {checkedLabel(Boolean(event[option.field]))}
              </Text>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'recalculate') {
    return (
      <section className="recalc-eval-datasets fs-unmask" aria-label="When evaluating">
        <Label label="When evaluating" showAsterisk={false} showIcon={false} />
        <div className="recalc-eval-datasets__rows">
          {EVALUATION_NORMALIZATION_OPTIONS.map((option) => (
            <React.Fragment key={option.key}>
              <Text variant="detail-regular" color="secondary">
                {option.label}
              </Text>
              <Text variant="detail-regular">
                {checkedLabel(Boolean(event[option.field]))}
              </Text>
            </React.Fragment>
          ))}
        </div>
      </section>
    );
  }

  return (
    <div>
      <Text variant="base-semibold" color="primary" as="div">
        When evaluating
      </Text>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
        {EVALUATION_NORMALIZATION_OPTIONS.map((option) => (
          <div
            key={option.key}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 8,
            }}
          >
            <Text variant="base-regular" color="secondary" as="span">
              {option.label}
            </Text>
            <Text variant="base-regular" color="secondary" as="span">
              {checkedLabel(Boolean(event[option.field]))}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}
